import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../api/axiosInstance';
import DateFormatter from '../utils/DateFormatter'
import MemberOfList from './MemberOfList';


const UserPage = () => {
  const { id } = useParams();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
        try {
          // Make sure to use the correct backend URL
          const response = await axiosInstance.get(`/api/user/${id}`);
          setUserData(response.data);
        } catch (error) {
          console.error("Error fetching user data:", error);
        }
      };
    fetchUserData();
  }, [id]);

  if (!userData) return <div>Loading...</div>;

  return (
    <div>
      <h2>User Info</h2>
      <p>Email: {userData.email}</p>

      <p>Last Active: {DateFormatter.formatDate(userData.last_seen)}</p>     
        <MemberOfList teamId={id} />
    </div>
    

  );
};

export default UserPage;
